import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import { registerServiceWorker } from "./pwa/registerSW";

import "./app/styles/tokens.css";
import "./app/styles/themes.css";
import "./app/styles/liquidGlass.css";
import "./app/styles/ui.css";
import "./app/styles/motion.css";
import "./app/styles/topBar.css";
import "./app/styles/shell.css";
import "./app/styles/bottomNav.css";
import "./app/styles/overflowMenu.css";

import "./app/styles/pages/home.css";
import "./app/styles/pages/schedule.css";
import "./app/styles/pages/deadlines.css";
import "./app/styles/pages/settings.css";
import "./app/styles/pages/map.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Register Service Worker for PWA
if (import.meta.env.PROD) {
  registerServiceWorker().catch(console.error);
}
